import { render } from "./checkout_realizado.vue?vue&type=template&id=1d9da518"
import script from "./checkout_realizado.vue?vue&type=script&lang=js"
export * from "./checkout_realizado.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__